export const StorageKeys = {
	Country: 'country',
	Language: 'language',
	AccessToken: 'accessToken',
};
